import { render, staticRenderFns } from "./Map-1-star.vue?vue&type=template&id=bee55b26&scoped=true&"
import script from "./Map-1-star.vue?vue&type=script&lang=js&"
export * from "./Map-1-star.vue?vue&type=script&lang=js&"
import style0 from "./Map-1-star.vue?vue&type=style&index=0&id=bee55b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee55b26",
  null
  
)

export default component.exports